import React from "react";
import { Dialog, DialogContent, Typography, Button, Box } from "@mui/material";
import CancleIcon from "../../assets/cancle.png"; // adjust path

const CancelOrderModal = (props) => {
  return (
    <Dialog
      open={true}
      onClose={() => props.setCancleflag(false)}
      PaperProps={{
        sx: {
          borderRadius: "20px",
          width: "300px",
          position: "relative",
          overflow: "visible", // enables floating icon
        },
      }}
    >
      {/* Floating Cancel Icon */}
      <Box
        component="img"
        src={CancleIcon}
        alt="Cancel Icon"
        sx={{
          position: "absolute",
          top: "-40px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "70px",
          height: "70px",
        }}
      />

      <DialogContent
        sx={{
          pt: "45px",
          textAlign: "center",
          fontFamily: "Roboto",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#ca1e1eff",
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "28px",
            letterSpacing: "1px",
          }}
        >
          Cancel Order?
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mt: 1,
            color: "rgba(56, 79, 111, 0.69)",
            fontSize: "12px",
            lineHeight: "20px",
          }}
        >
          Do you want to cancel the order?
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            mt: 4,
          }}
        >
          <Button
            onClick={() => props.setCancleflag(false)}
            sx={{
              width: "40%",
              borderRadius: "10px",
              border: "1px solid rgb(0, 177, 119)",
              color: "rgb(0, 177, 119)",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": { backgroundColor: "rgba(56, 79, 111, 0.08)" },
            }}
          >
            NO
          </Button>

          <Button
            onClick={props.CancleOrder}
            sx={{
              width: "40%",
              borderRadius: "10px",
              backgroundColor: "rgb(0, 177, 119)",
              color: "#fff",
              fontWeight: 600,
              textTransform: "none",
              "&:hover": { backgroundColor: "#2f415e" },
            }}
          >
            YES
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CancelOrderModal;
